import { z } from "zod";
import { makeGetRequest } from "../../utils";

type GetDailyUsageReportOptions = {
	year: number;
	month: number;
};

const DatesSchema = z.object({
	date: z.string(),
	sessions: z.number(),
	users: z.number(),
	session_minutes: z.number(),
});

const GetDailyUsageReportResponseSchema = z.object({
	year: z.number(),
	month: z.number(),
	dates: z.array(DatesSchema),
});

type GetDailyUsageReportResponse = z.infer<
	typeof GetDailyUsageReportResponseSchema
>;

const getDailyUsageReport = async (
	token: string,
	options: GetDailyUsageReportOptions,
): Promise<GetDailyUsageReportResponse> => {
	const res = await makeGetRequest({
		token,
		pathList: ["v2", "videosdk", "report", "daily"],
		options,
	});
	return GetDailyUsageReportResponseSchema.parse(res);
};

export const curriedGetDailyUsageReport = (token: string) => (
	options: GetDailyUsageReportOptions,
) => getDailyUsageReport(token, options);